<template>
    <div class="chatMessage" :class="{ right: message.senderIdentifier == userId, left: message.senderIdentifier != userId, selected: flagged }">
        <div class="utils" v-if="canRemove">
            <button type="button" class="btn btn-danger" @click="emitRemove">
                <icon-close></icon-close>
            </button>
        </div>
        <div class="quotedMessage" v-if="message.quotedMessage">
            <p class="sender" :class="{'text-green': message.fromBackend}">{{message.quotedMessage.sender}}</p>
            <span v-html="message.quotedMessage.text"></span>   
        </div>
        <div>
            <router-link :to="'/users/' + message.senderIdentifier" class="sender" :class="{'text-green': message.fromBackend}">
                {{message.sender}}
            </router-link>
        </div>
        <span v-html="message.text" ref="messageContainer"></span>
        <small class="timestamp">{{$filters.date(message.timestamp, 'DD-MM-YYYY HH:mm') }}</small>
    </div>
</template>

<script lang="ts">
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import { Options, Vue } from 'vue-class-component';
import store from '@/store';

@Options({})
export default class chatMessage extends Vue {
    nowstamp: number = new Date().getTime();
    userId: string = store.state.loginData.userIdentifier;
    flagged: boolean = false;

    @Prop() canRemove: boolean;
    @Prop() messagesToRemove: OM.ChatMessage[];
    @Prop({
        type: [Object, OM.ChatMessage]
    }) message: OM.ChatMessage;

    @Watch('messagesToRemove.length')
    onMessagesToRemoveChange(next, prev){
        if(next == 0){
            this.flagged = false;
        }
    }

    getElapsedTime(timestamp: number){
        let elapsed = this.nowstamp - timestamp;
        let minutes = elapsed / 1000 / 60;
        if(minutes > 60){
            let hours = minutes / 60;
            if(hours > 24){
                let days = hours / 24;
                return Math.abs(days).toFixed(0) + ' giorni fa';
            } else {
                return Math.abs(hours).toFixed(0) + ' ore fa';
            }
        } else {
            return Math.abs(minutes).toFixed(0) + ' minuti fa';
        }
    }
    
    mounted(){
        let container: any = this.$refs.messageContainer;
        let imgs = container.querySelectorAll('._chatImg');
        imgs.forEach(x => {
            x.addEventListener('click', (ev) => {
                let background = getComputedStyle(ev.target).backgroundImage;
                let splitted = background.split(',');
                let url = splitted[0].substring(5, splitted[0].length -2);
                window.open(url, '_blank');
            });
        })
    }

    emitRemove(){
        this.flagged = !this.flagged;
        this.$emit('removeMessage', this.message);
    }
    
}
</script>

